import request from "@/utils/request";

// 登录
export function login(data) {
  return request({
    method: "post",
    path: "auth/login",
    data,
  });
}
// 二维码登录
export function qrcodeLogin(data) {
  return request({
    method: "post",
    path: "auth/qrcodeLogin",
    data,
  });
}

// 注册
export function register(data) {
  return request({
    method: "post",
    path: "auth/register",
    data,
  });
}

// 忘记密码
export function forget(data) {
  return request({
    method: "post",
    path: "auth/forget",
    data,
  });
}

// 获取登录二维码
export function getWeixinQrcode(data) {
  return request({
    method: "post",
    path: "auth/getWeixinQrcode",
    data,
  });
}

// 检测二维码扫描结果并登录
export function checkByWeixinQrcode(data) {
  return request({
    method: "post",
    path: "auth/checkByWeixinQrcode",
    data,
  });
}
